<template>
  <div>
    <v-dialog fullscreen hide-overlay lazy v-model="dialog">
      <v-card>
        <v-toolbar
          color="primary"
          dark
          :style="
            step == 2 && drawer && !isMobile
              ? 'margin-left:260px;width: auto;'
              : ''
          "
        >
          <v-toolbar-title>
            <v-toolbar-side-icon
              v-if="step == 2 && !drawer"
              @click.stop="drawer = !drawer"
              dark
              style="margin: 0;"
            ></v-toolbar-side-icon>
            {{ title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="dialog = false" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-stepper v-model="step">
          <v-stepper-header
            :style="step == 2 && drawer && !isMobile ? 'margin-left:260px' : ''"
          >
            <v-stepper-step :complete="e1 > 1" :step="1" @click="step = 1"
              >Datos basicos</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              v-if="
                externalMatch._id &&
                  can('edit', 'match', matchId) &&
                  (externalMatch.video || externalMatch.youtubeVideo)
              "
              :complete="e1 > 2"
              :step="2"
              @click="step = 2"
              >{{ $tc('event', 2) }}</v-stepper-step
            >
          </v-stepper-header>
          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex md3 sm3 xs6>
                      <v-switch
                        v-model="active"
                        :disabled="!Edit"
                        :label="$t('active')"
                        color="primary"
                      ></v-switch>
                    </v-flex>
                    <v-flex md3 sm3 xs6>
                      <v-switch
                        v-model="finalized"
                        :disabled="!Edit"
                        :label="$t('finalized')"
                        color="primary"
                      ></v-switch>
                    </v-flex>
                    <v-flex md6 sm6 xs12>
                      <v-select
                        :disabled="!Edit || !!tournament._id"
                        :items="types"
                        :rules="[v => rules.vacio(v, 'type')]"
                        required
                        v-model="type"
                        @change="onChangeType"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{ $t('type') }}
                        </template>
                      </v-select>
                    </v-flex>
                    <v-flex md6 sm6 xs12>
                      <v-select
                        v-if="phase && phase.hours && phase.hours.length"
                        :items="phase.hours"
                        :rules="[v => rules.vacio(v, 'time')]"
                        required
                        v-model="time"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{ $t('time') }}
                        </template>
                      </v-select>
                      <v-menu
                        v-else
                        ref="menuTime"
                        v-model="menuTime"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="time"
                            :disabled="!Edit"
                            prepend-icon="access_time"
                            readonly
                            v-on="on"
                          >
                            <template slot="label">
                              <span style="color: red">*</span>
                              {{ $t('time') }}
                            </template>
                          </v-text-field>
                        </template>
                        <v-time-picker
                          v-model="time"
                          v-if="menuTime"
                          full-width
                          @click:minute="$refs.menuTime.save(time)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex md6 sm6 xs12>
                      <v-menu
                        ref="menu"
                        v-model="menuDate"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="dateFormatted"
                            :disabled="!Edit"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          >
                            <template slot="label">
                              <span style="color: red">*</span>
                              {{ $t('date') }}
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker
                          v-if="!loadingTournament"
                          v-model="date"
                          no-title
                          :min="tournamentStartDate"
                          :max="tournamentEndDate"
                          scrollable
                          :first-day-of-week="1"
                          locale="es-ES"
                          @change="onChangeDate"
                        >
                        </v-date-picker>
                      </v-menu>
                    </v-flex>
                    <v-flex v-if="type === 'tournament'" md6 s6 xs12>
                      <v-autocomplete
                        :disabled="!Edit || !!tournament._id"
                        :items="listTournamentsFormat"
                        :rules="
                          type !== 'tournament'
                            ? []
                            : [v => rules.vacio(v, 'tournament')]
                        "
                        v-model="tournamentId"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{ $tc('tournament') }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md6 s6 xs12>
                      <v-autocomplete
                        :disabled="!Edit"
                        :items="
                          type === 'tournament' ? tournamentAct : listActs
                        "
                        :rules="
                          type === 'tournament' && !tournamentId
                            ? []
                            : [v => rules.vacio(v, 'act')]
                        "
                        v-model="actIdReal"
                      >
                        <template slot="label">
                          <span style="color: red">*</span>
                          {{ $t('select', { field: $tc('act') }) }}
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md12 sm6 xs12>
                      <v-autocomplete
                        v-model="judges"
                        :disabled="!Edit"
                        :items="listUsers"
                        chips
                        :label="$t('select', { field: $t('judges') })"
                        item-text="text"
                        item-value="value"
                        multiple
                        @change="searchJudges = ''"
                        :search-input.sync="searchJudges"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            color="white"
                            :selected="data.selected"
                            close
                            @input="removeJudge(data.item)"
                            class="chip--select-multi"
                          >
                            <v-avatar>
                              <img :src="data.item.photo" />
                            </v-avatar>
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-tile-avatar>
                            <img :src="data.item.photo" />
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="data.item.text"
                            ></v-list-tile-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex md12 sm6 xs12>
                      <v-autocomplete
                        v-model="location"
                        :disabled="!Edit || !!externalLocation"
                        :items="listStadiumsPitches"
                        chips
                        :label="$t('select', { field: $t('location') })"
                        item-text="text"
                        item-value="value"
                      >
                        <template v-slot:selection="data">
                          <v-chip
                            color="white"
                            :selected="data.selected"
                            class="chip--select-multi"
                          >
                            <v-avatar>
                              <img :src="`${data.item.photo}`" />
                            </v-avatar>
                            {{ data.item.text }}
                          </v-chip>
                        </template>
                        <template v-slot:item="data">
                          <v-list-tile-avatar>
                            <img :src="`${data.item.photo}`" />
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title
                              v-html="data.item.text"
                            ></v-list-tile-title>
                            <v-list-tile-sub-title
                              v-html="data.item.group"
                            ></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <template
                      v-if="
                        type === 'user' ||
                          tournament.type == 'users' ||
                          tournament.type == 'usersTeams'
                      "
                    >
                      <v-flex md12 sm6 xs12>
                        <v-autocomplete
                          v-model="user"
                          :disabled="!Edit"
                          :items="filteredUsers"
                          chips
                          :label="$t('select', { field: $tc('user') })"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              color="white"
                              :selected="data.selected"
                              class="chip--select-multi"
                            >
                              <v-avatar>
                                <img :src="data.item.photo" />
                              </v-avatar>
                              {{ data.item.text }}
                            </v-chip>
                          </template>
                          <template v-slot:item="data">
                            <v-list-tile-avatar>
                              <img :src="data.item.photo" />
                            </v-list-tile-avatar>
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.text"
                              ></v-list-tile-title>
                              <v-list-tile-sub-title v-if="data.item.teams">
                                <v-chip
                                  class="my-0"
                                  small
                                  v-for="team of data.item.teams"
                                  :key="team._id"
                                >
                                  <v-avatar v-if="team.logo">
                                    <v-img :src="team.logo" />
                                  </v-avatar>
                                  {{ team.name }}
                                </v-chip>
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </template>
                    <template v-else>
                      <v-flex md12 sm12 xs12>
                        <v-autocomplete
                          v-model="teams"
                          :disabled="!Edit"
                          :items="filteredTeams"
                          chips
                          :label="$t('select', { field: $tc('team', 2) })"
                          multiple
                          ref="teams"
                          @change="searchTeams = ''"
                          :search-input.sync="searchTeams"
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              color="white"
                              :selected="data.selected"
                              class="chip--select-multi"
                              close
                              @input="removeTeam(data.item)"
                              >{{ data.item.text }}</v-chip
                            >
                          </template>
                          <template v-slot:item="data">
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.text"
                              ></v-list-tile-title>
                              <v-list-tile-sub-title
                                v-html="data.item.entity"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex md6 sm6 xs12>
                        <v-autocomplete
                          v-model="homeTeamId"
                          :disabled="!Edit"
                          :items="
                            filteredTeams.filter(
                              team => teams && teams.includes(team.value)
                            )
                          "
                          chips
                          :label="$t('homeTeam')"
                          ref="homeTeamId"
                        >
                          <template v-slot:selection="data">{{
                            data.item.text
                          }}</template>
                          <template v-slot:item="data">
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.text"
                              ></v-list-tile-title>
                              <v-list-tile-sub-title
                                v-html="data.item.entity"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </v-flex>

                      <v-flex md6 sm6 xs12>
                        <v-autocomplete
                          v-model="visitorTeamId"
                          :disabled="!Edit"
                          :items="
                            filteredTeams.filter(
                              team => teams && teams.includes(team.value)
                            )
                          "
                          chips
                          :label="$t('visitorTeam')"
                          ref="visitorTeamId"
                        >
                          <template v-slot:selection="data">{{
                            data.item.text
                          }}</template>
                          <template v-slot:item="data">
                            <v-list-tile-content>
                              <v-list-tile-title
                                v-html="data.item.text"
                              ></v-list-tile-title>
                              <v-list-tile-sub-title
                                v-html="data.item.entity"
                              ></v-list-tile-sub-title>
                            </v-list-tile-content>
                          </template>
                        </v-autocomplete>
                      </v-flex>
                    </template>

                    <v-flex md6 sm6 xs12>
                      <v-text-field
                        v-model="titleFile"
                        :label="$t('video')"
                        disabled
                        prepend-icon="attach_file"
                      ></v-text-field>
                      <v-flex d-flex xs12 text-xs-left>
                        <v-btn
                          v-if="video"
                          @click="resetVideo()"
                          color="warning"
                          small
                          >{{ $t('reset') }}</v-btn
                        >
                        <upload-button
                          small
                          :color="!Edit || !!youtubeVideo ? 'gray' : 'primary'"
                          :fileChangedCallback="fileChanged"
                          :title="$t('upload', { field: $t('video') })"
                          :disabled="!Edit || !!youtubeVideo"
                        />
                      </v-flex>

                      <video
                        v-if="video"
                        :src="video"
                        width="480"
                        height="360"
                        controls
                      ></video>
                    </v-flex>
                    <v-flex md6 sm6 xs12>
                      <v-text-field
                        v-model="youtubeVideo"
                        :label="$t('youtubeVideo')"
                        :rules="
                          youtubeVideo && !youtubeVideoUrl
                            ? [v => $t('error.invalidYoutubeVideo')]
                            : []
                        "
                        :disabled="!Edit || !!video"
                      ></v-text-field>

                      <iframe
                        v-if="youtubeVideoUrl"
                        :src="youtubeVideoUrl"
                        width="480"
                        height="360"
                        frameborder="0"
                        allowfullscreen
                      ></iframe>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-stepper-content>
            <v-stepper-content
              v-if="
                externalMatch._id &&
                  can('edit', 'match', matchId) &&
                  (externalMatch.video || externalMatch.youtubeVideo)
              "
              step="2"
              class="pt-0"
            >
              <tab-events :drawer.sync="drawer"></tab-events>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-card-actions>
          <span style="color:red">*</span>
          <span>{{ $t('messages.fieldRequired') }}</span>
          <v-spacer></v-spacer>
          <v-btn v-if="step === 2" @click="step--" color="success" small>{{
            $t('previous')
          }}</v-btn>

          <v-btn
            v-if="Edit && !externalMatch._id"
            @click="resetForm()"
            color="warning"
            small
            >{{ $t('reset') }}</v-btn
          >
          <!-- v-if="(e1==='2' || e1===2) && externalAction === 'create'" -->
          <v-btn
            v-if="!externalMatch._id"
            @click="enviarForm()"
            color="success"
            small
            :loading="loading"
            >{{ $t('save') }}</v-btn
          >
          <!-- v-if="(e1==='2' || e1===2) && externalAction === 'update'" -->
          <v-btn
            v-if="
              externalAction === 'update' &&
                externalMatch._id &&
                step != 2 &&
                canUpdate
            "
            @click="updateForm()"
            color="secondary"
            small
            :loading="loading"
            >{{ $t('update') }}</v-btn
          >
          <!-- v-if="(e1==='2' || e1===2) && externalAction === 'remove'" -->
          <v-btn
            v-if="externalAction === 'remove' && canDelete"
            @click="removeForm()"
            color="error"
            small
            :loading="loading"
            >{{ $t('delete') }}</v-btn
          >
          <!-- v-if="e1 === '1' || e1 === 1" -->
          <v-btn
            v-if="
              step == 1 &&
                externalMatch._id &&
                (externalMatch.video || externalMatch.youtubeVideo)
            "
            @click="step++"
            color="success"
            small
            >{{ $t('next') }}</v-btn
          >
          <!-- v-if="e1 === '2' || e1 === 2" -->
          <!-- <v-btn v-if="false" @click="e1 = 1" color="success" small>Anterior</v-btn> -->
          <v-btn @click="dialog = false" color="primary" small>{{
            $t('cancel')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import UploadButton from 'vuetify-upload-button'
import 'video.js/dist/video-js.css'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'
import tabEvents from './tabEvents'
import {
  timeFormat,
  parseTime,
  formatDate,
  dateFormat,
  formatDatePicker
} from '../../../helpers/dateHelper'

export default {
  name: 'formManager',
  components: { UploadButton, tabEvents },
  mixins: [rules],
  props: {
    modal: {
      type: Boolean,
      required: false,
      default: false
    },
    externalMatch: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    externalAction: {
      type: String,
      required: false,
      default: 'create'
    },
    externalType: {
      type: String,
      required: false,
      default: ''
    },
    Edit: {
      type: Boolean,
      required: false,
      default: true
    },
    // tournament: {
    //   type: Object,
    //   required: false,
    //   default: () => {
    //     return {}
    //   }
    // },
    phase: {
      type: Object,
      required: false,
      default: () => {
        return {}
      }
    },
    externalLocation: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      searchTeams: '',
      searchJudges: '',

      drawer: true,
      loading: false,
      step: 1,
      menuDate: false,
      menuTime: false,
      today: new Date(),
      types: [
        {
          text: this.$t('types.tournament'),
          value: 'tournament'
        },
        {
          text: this.$t('types.friendly'),
          value: 'friendly'
        },
        {
          text: this.$t('types.user'),
          value: 'user'
        }
      ],
      e1: 1,
      file: '',
      titleFile: '',

      type: '',
      active: true,
      finalized: false,
      date: formatDatePicker(new Date().toISOString()),
      dateFormatted: formatDate(new Date().toISOString()),
      time: null,
      actId: '',
      tournamentId: '',
      actIdReal: '',
      judges: [],
      location: '',
      homeTeamId: '',
      visitorTeamId: '',

      eventsCreated: [],
      homeTeamLineUp: [],
      visitorTeamLineUp: [],

      video: '',
      youtubeVideo: '',

      teams: [],
      user: '',

      tournamentStartDate: null,
      tournamentEndDate: null,

      eventsCreatedTemplate: {
        teamId: '', // Cuando el evento está relacionado con algún equipo, id del equipo.
        userId: '', // Cuando el evento está relacionado con algún jugador, id del user.
        minute: Number, // Minuto de creación del evento.
        second: Number, // Segundo de creación del evento
        additionalContent: '', // Contenido adicional del evento.
        likes: [], // userId.
        shared: [] // userId.
      },
      homeTeamLineUpTemplate: {
        userId: '', // Cuando el evento está relacionado con algún jugador, id del user.
        position: '', // Posición del jugador en el campo.
        dorsal: Number // Dorsal del jugador.
      },
      visitorTeamLineUpTemplate: {
        userId: '', // Cuando el evento está relacionado con algún jugador, id del user.
        position: '', // Posición del jugador en el campo.
        dorsal: Number // Dorsal del jugador.
      }
    }
  },
  mounted() {},
  watch: {
    step(val) {
      if (val == 2) this.drawer = true
    },
    type: function(val) {
      if (val === 'user') {
        this.teams = []
        this.homeTeamId = ''
        this.visitorTeamId = ''
      } else {
        this.user = ''
      }
      if (val != 'tournament') this.tournamentId = ''
    },
    homeTeamId: function(newValue, oldValue) {
      if (
        newValue === this.visitorTeamId &&
        this.teams &&
        this.teams.length &&
        this.teams.includes(oldValue)
      ) {
        this.visitorTeamId = oldValue
      }
      if (!newValue) newValue = ''
    },
    visitorTeamId: function(newValue, oldValue) {
      if (
        newValue === this.homeTeamId &&
        this.teams &&
        this.teams.length &&
        this.teams.includes(oldValue)
      ) {
        this.homeTeamId = oldValue
      }
      if (!newValue) newValue = ''
    },
    teams: function(val) {
      if (val) {
        if (val.length > 2) val.pop()
        if (!val.includes(this.homeTeamId)) this.homeTeamId = ''
        if (!val.includes(this.visitorTeamId)) this.visitorTeamId = ''
      }
    },
    act: function(val) {
      const vm = this
      if (val && val._id) {
        setTimeout(() => {
          vm.actIdReal = val._id
        }, 50)
      }
    },
    tournamentId: function(val) {
      if (val && val != this.tournament._id) {
        this.getOneTournament(val).then(() => {
          this.tournamentStartDate = formatDatePicker(this.tournament.startAt)
          this.tournamentEndDate = formatDatePicker(this.tournament.endAt)
        })
      } else if (!val && this.externalType != 'tournament') {
        this.clearOneTournament()
        this.tournamentStartDate = null
        this.tournamentEndDate = null
      } else if (val != this.tournament._id) {
        this.actId = ''
        this.actIdReal = ''
        this.teams = []
        this.homeTeamId = ''
        this.visitorTeamId = ''
        this.user = ''
      }
    },
    tournament: function(val) {
      this.setTournamentData()
    },
    dialog(val) {
      if (val && this.externalType == 'tournament') this.setTournamentData()
    },
    // externalAction: function (val) {
    //   this.updateAction();
    // },
    externalMatch: function(val) {
      this.updateMatch()
      // this.updateAction();
    }
  },
  computed: {
    ...mapState({
      listActs: state => state.acts.listSelect,
      listUsers: state => state.users.listSelectUsers,
      listStadiums: state => state.stadiums.listStadiums,
      listTournaments: state => state.tournaments.listSelect,
      listTeams: state => state.teams.listSelectTeams,
      act: state => state.acts.actSelected,
      matchId: state => state.matches.idSelected,
      tournament: state => state.tournaments.selected,
      loadingTournament: state => state.tournaments.loading,
      authUser: state => state.authentication.user
    }),
    title() {
      if (this.externalMatch._id) {
        return `${this.externalMatch.time || this.$t('time')} ${this.dateFormat(
          this.externalMatch.date
        ) || this.$t('date')} - ${this.getUserOrTeam().toUpperCase()}`
      } else return this.$t('newModel', { field: this.$tc('match') })
    },
    tournamentAct() {
      if (!this.tournament || !this.tournament._id) return []
      return [{ value: this.tournament.act, text: this.tournament.actName }]
    },
    listTournamentsFormat() {
      return this.listTournaments.filter(tournament =>
        this.can('edit', 'tournament', tournament)
      )
    },
    listStadiumsPitches() {
      let listSelect = []
      let listStadiums = this.listStadiums
      let isTrainer = !this.isAdmin && this.hasRole('teams')
      if (isTrainer) {
        listStadiums = listStadiums.filter(
          stadium =>
            this.authUser &&
            this.authUser.entities &&
            this.authUser.entities.some(entity =>
              entity.stadiumId.includes(stadium._id)
            )
        )
      }

      listStadiums.forEach((stadium, index) => {
        if (
          this.tournament._id &&
          !this.tournament.stadiumId.includes(stadium._id)
        ) {
          return
        }
        if (stadium.pitches.length) {
          if (index !== 0) listSelect.push({ divider: true })
          listSelect.push({ header: stadium.name })
        }

        stadium.pitches.forEach(pitch => {
          let item = {
            group: stadium.name,
            text: pitch.name,
            value: pitch._id,
            photo: process.env.VUE_APP_IMAGE_URL + pitch.photo
          }

          listSelect.push(item)
        })
      })
      return listSelect
    },

    filteredTeams() {
      let listTeams = []
      if (this.type === 'tournament' && this.tournament.users) {
        listTeams = this.tournament.teams.map(item => ({
          value: item.teamId,
          text: item.name,
          entity: item.entity
        }))
      } else listTeams = this.listTeams
      return listTeams
    },
    filteredUsers() {
      let listUsers = []
      if (this.type === 'tournament' && this.tournament.users) {
        listUsers = this.tournament.users.map(item => ({
          value: item.userId,
          text: item.name,
          photo: process.env.VUE_APP_IMAGE_URL + item.photo
        }))
      } else {
        listUsers = this.listUsers.filter(user =>
          user.roles.includes('participant')
        )
      }
      return listUsers
    },
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        if (!value) {
          this.step = 1
          this.$emit('close')
          let vm = this
          setTimeout(() => {
            vm.resetForm()
          }, 500)
        }
      }
    },
    youtubeVideoUrl() {
      if (!this.youtubeVideo) return ''
      const url = 'https://www.youtube.com/embed/'
      let video
      if (
        this.youtubeVideo.includes('youtube') &&
        this.youtubeVideo.split('?v=').length
      ) {
        video = this.youtubeVideo.split('?v=')[1]
      } else if (this.youtubeVideo.includes('youtu.be')) {
        let videoId = this.youtubeVideo.split('youtu.be/')
        if (videoId.length && videoId[1]) video = videoId[1]
      }

      if (video) return url + video
      else return ''
    },
    canUpdate() {
      if (!this.externalMatch) return false
      return (
        this.can('edit', 'match', this.externalMatch) ||
        (this.externalMatch.tournamentId &&
          this.tournament &&
          this.can('edit', 'tournament', this.tournament))
      )
    },
    canDelete() {
      if (!this.externalMatch) return false
      return (
        this.can('delete', 'match', this.externalMatch) ||
        (this.externalMatch.tournamentId &&
          this.tournament &&
          this.can('edit', 'tournament', this.tournament))
      )
    }
  },
  methods: {
    ...mapActions({
      setCreate: 'matches/setNew',
      setUpdate: 'matches/setUpdate',
      setRemove: 'matches/setDelete',
      getOneTournament: 'tournaments/setOne',
      clearOneTournament: 'tournaments/setClearOne'
    }),
    // updateAction() {
    //   switch (this.externalAction) {
    //     case "update":
    //     case "remove":
    //       this.updateMatch();
    //       this.Edit = this.externalAction === "update";
    //       break;
    //     default:
    //       this.resetForm();
    //       this.Edit = true;
    //   }
    // },
    updateMatch() {
      if (Object.keys(this.externalMatch).length === 0) {
        this.resetForm()
        return
      }
      const match = this.externalMatch

      this.active = match.active
      this.finalized = match.finalized
      this.type = match.type
      this.date = formatDatePicker(match.date)
      this.dateFormatted = formatDate(this.date)
      this.time = match.time
      this.tournamentId = match.tournamentId
      this.eventsCreated = match.eventsCreated
      this.homeTeamLineUp = match.homeTeamLineUp
      this.visitorTeamLineUp = match.visitorTeamLineUp
      this.video = match.video
      this.youtubeVideo = match.youtubeVideo
      const vm = this
      setTimeout(() => {
        vm.judges = match.judges
        vm.location = match.location
        vm.homeTeamId = match.homeTeamId
        vm.visitorTeamId = match.visitorTeamId
        vm.teams = match.teams
        vm.user = match.user
        vm.actId = match.actId
      }, 100)
    },
    resetForm() {
      this.active = true
      this.finalized = false
      this.type = ''
      this.date = formatDatePicker(new Date().toISOString())
      this.dateFormatted = ''
      this.time = null
      this.actId = ''
      this.actIdReal = ''
      this.tournamentId = ''
      this.judges = []
      this.location = this.externalLocation || ''
      this.homeTeamId = ''
      this.visitorTeamId = ''
      this.eventsCreated = []
      this.homeTeamLineUp = []
      this.visitorTeamLineUp = []
      this.video = ''
      this.youtubeVideo = ''
      this.teams = []
      this.user = ''
      this.tournamentStartDate = null
      this.tournamentEndDate = null
      this.file = ''
      this.titleFile = ''
      this.setTournamentData()
    },
    setTournamentData() {
      const vm = this
      if (vm.tournament._id) {
        setTimeout(() => {
          vm.tournamentId = vm.tournament._id
          vm.type = 'tournament'
          // vm.date = ''
          vm.tournamentStartDate = formatDatePicker(vm.tournament.startAt)
          vm.tournamentEndDate = formatDatePicker(vm.tournament.endAt)
          // if (!vm.time) vm.time = '00:00'
          vm.actIdReal = vm.tournament.act
        }, 20)
      }
    },
    errorFormPaso1() {
      let error = false
      let message = []
      if (!this.type) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('type') }))
      }
      if (!this.date) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('date') }))
      }
      if (!this.time) {
        error = true
        message.push(this.$t('error.required', { field: this.$t('time') }))
      }
      if (!this.actIdReal && this.type != 'tournament') {
        error = true
        message.push(this.$t('error.required', { field: this.$tc('act') }))
      }
      if (this.type == 'tournament' && !this.tournamentId) {
        error = true
        message.push(
          this.$t('error.required', { field: this.$tc('tournament') })
        )
      }
      if (
        this.homeTeamId &&
        this.visitorTeamId &&
        this.homeTeamId == this.visitorTeamId
      ) {
        error = true
        message.push(this.$t('error.equalTeams'))
      }
      if (this.youtubeVideo && !this.youtubeVideoUrl) {
        error = true
        message.push(this.$t('error.invalidYoutubeVideo'))
      }
      return {
        error,
        message
      }
    },
    validarForm() {
      const paso1 = this.errorFormPaso1()
      if (paso1.error) {
        queueToast(paso1.message)
        return false
      }
      return true
    },
    createMatch() {
      let result = {
        type: this.type,
        active: this.active,
        finalized: this.finalized,
        date: this.date,
        time: this.time,
        tournamentId: this.tournamentId,
        judges: this.judges.slice(),
        location: this.location,
        homeTeamId: this.homeTeamId,
        visitorTeamId: this.visitorTeamId,
        eventsCreated: this.eventsCreated.slice(),
        homeTeamLineUp: this.homeTeamLineUp.slice(),
        visitorTeamLineUp: this.visitorTeamLineUp.slice(),
        youtubeVideo: this.youtubeVideo,
        video: this.video,
        teams: this.teams.slice(),
        user: this.user,
        file: this.file,
        tournamentView: !!this.tournamentId
      }
      if (!this.externalMatch._id) result.actId = this.actIdReal
      else if (this.actIdReal !== this.act._id) result.actId = this.actIdReal

      if (this.youtubeVideo) result.video = ''
      if (this.video) result.youtubeVideo = ''
      return result
    },
    enviarForm() {
      if (!this.validarForm() || this.loading) return
      this.loading = true
      this.setCreate(this.createMatch())
        .then(match => this.$emit('created', match))
        .finally(() => {
          this.loading = false
          this.dialog = false
        })
      // this.dialog = false;
    },
    updateForm() {
      if (!this.validarForm() || this.loading) return

      let matchLocal = this.createMatch()
      matchLocal._id = this.externalMatch._id
      if (
        this.homeTeamId !== this.externalMatch.homeTeamId ||
        this.visitorTeamId !== this.externalMatch.visitorTeamId
      ) {
        matchLocal.finalScoreHomeTeam = null
        matchLocal.finalScoreVisitTeam = null
      }
      this.loading = true
      this.setUpdate(matchLocal) // .finally(() => this.dialog = false);
        .finally(() => (this.loading = false))
    },
    removeForm() {
      if (this.loading) return
      this.setRemove(this.externalMatch._id)
      this.dialog = false
    },
    removeJudge(item) {
      const index = this.judges.indexOf(item.value)
      if (index >= 0) this.judges.splice(index, 1)
    },
    removeTeam(item) {
      const index = this.teams.indexOf(item.value)
      if (index >= 0) this.teams.splice(index, 1)
    },
    fileChanged(file) {
      if (file.size < 1) return
      this.file = file
      this.titleFile = file.name
      const reader = new FileReader()
      const vm = this

      reader.onload = e => {
        vm.video = e.target.result
      }
      reader.readAsDataURL(file)
    },
    timeFormat(time) {
      return timeFormat(time, false)
    },
    dateFormat(date) {
      return dateFormat(date, false)
    },
    getUserOrTeam() {
      if (!this.externalMatch) return '-'
      let match = this.externalMatch
      if (!match) return this.$t('messages.searching')
      if (match.type === 'user') {
        return match.userName ? match.userName.name : '-'
      }
      if (
        this.tournament._id &&
        (this.tournament.type == 'users' ||
          this.tournament.type == 'usersTeams')
      ) {
        return match.userName ? match.userName.name : '-'
      }

      return `${match.homeTeam || this.$t('homeTeam')} vs ${match.visitorTeam ||
        this.$t('visitorTeam')}`
    },
    resetVideo() {
      this.video = ''
      this.file = ''
      this.titleFile = ''
    },
    formatDatePicker(date) {
      return formatDatePicker(date)
    },
    onChangeType(type) {
      if (type === 'tournament') {
        this.date = ''
        this.dateFormatted = ''
      }
    },
    onChangeDate(date) {
      this.dateFormatted = formatDate(date)
    }
  }
}
</script>
